<div class="star-rating">
  <div *ngFor="let star of stars; let i = index">
    <i class="" [ngClass]="{
      'bi bi-star-fill': i < rating,
      'bi bi-star': i >= rating
    }"></i>
  </div>
</div>